module.exports = __webpack_public_path__ + "static/media/project_img_logo.20611cba.jpg";